import React, { useEffect, useContext, useState } from 'react';
import ComponentProvider, { ComponentContext } from '../ComponentProvider';

export const BundleProgressBar = () => {
  const { tiersState, bundleState } = useContext(ComponentContext);
  const [tiers] = tiersState
  const [bundle] = bundleState

  const [currentProgress, setCurrentProgress] = useState(0)

  useEffect(() => {
    const productsTotal = bundle.reduce((acc, curr) => acc + curr.quantity, 0)
    if (productsTotal <= (tiers.length + 1)) {
      setCurrentProgress((productsTotal / (tiers.length + 1) * 100))
    }
  }, [bundle])

  return (
    <div className='BundleProgressBar' >
      <span className='BundleProgressBar__inner' style={{ width: `${currentProgress}%` }}></span>
      {tiers.map((t, index) => {
        const tierValue = (100 / tiers.length) * (index + 1)
        return (
          <div className='BundleProgressBar__tier' style={{ left: `${tierValue}%` }} key={`tier-marker-${index}`}>
            <div className={`BundleProgressBar__tier__marker ${currentProgress >= tierValue ? 'unlocked' : ''}`}>
              <span>{t.title}</span>
            </div>
          </div>
        )
      })}
      <div className='BundleProgressBar__list'>
        {tiers.map((t, index) => {
          const tierValue = (100 / tiers.length) * (index + 1)
          return (
            <div className="BundleProgressBar__list__marker" style={{ left: `${tierValue}%` }} key={`tier-list-marker-${index}`}>
              <span>{t.discount_text}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
